import React from "react";
import { Paper, Box } from "@mui/material";
import CustomText from "../CustomText";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import arrowdown from "../../assets/arrowdown.svg";

const IndustryCard = ({ title, description, onExpand, sx,  onMouseEnter,
  onMouseLeave,
  isActive, 
  onClick,
ref }) => {
  return (
    <Paper
       ref={ref}
      elevation={0}
      sx={{
        p: 4,
        borderRadius: "24px",
        backgroundColor: "white",
        boxShadow: "0px 4px 25px 0px rgba(141, 141, 141, 0.05)",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        cursor: "pointer",
        "&:hover": {
          boxShadow: "0px 4px 25px 0px rgba(141, 141, 141, 0.1)",
        },
        ...sx,
      }}
      // onClick={onExpand}
      onClick={onClick}
  onMouseEnter={onMouseEnter}
  onMouseLeave={onMouseLeave}

    >
      <Box sx={{ flex: 1, pr: 3 }}>
        <CustomText
          customStyle={{
            fontSize: "20px",
            fontWeight: 600,
            fontFamily: "Poppins, sans-serif",
            color:"#363333",
            textAlign: "left",
            marginBottom: "20px",
            lineHeight:"1.3"
          }}
        >
          {title}
        </CustomText>
        <CustomText
        style={{
            fontSize: "16px",
          fontWeight: 500,
          fontFamily: "Nunito, sans-serif",
          color: "#868282",
          textAlign: "left",
          marginTop: "10px",
          lineHeight: "140%",
          }}
        >
          {description}
        </CustomText>
      </Box>
      <Box
        sx={{
          width: 50,
          height: 50,
          borderRadius: "50%",
          backgroundColor: isActive ? " #002A3F" : "white",
          border: isActive ? "1px solid transparent" : "1px solid #D1D3D9",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          transition: "all 0.3s ease", 
        }}
      >
 {isActive ? (
    <ArrowUpwardIcon sx={{ color: "white" }} />
  ) : (
    <img src={arrowdown}/>
  )}
      </Box>
    </Paper>
  );
};

export default IndustryCard;
